import { z } from 'zod';
import { currencyCodeSchema, dateOnlySchema, exchangeRateSchema } from './common';
/**
 * Exchange rates: the prefill query and the manual entry.
 *
 * A rate is "units of `to` per ONE unit of `from`" - `to` is the book's
 * base when omitted, so `?date=2026-08-01&from=GBP` is "rupees per pound on
 * 1 August".
 */
export const ratesQuerySchema = z
    .object({
    date: dateOnlySchema,
    from: currencyCodeSchema,
    to: currencyCodeSchema.optional(),
})
    .strict();
export const addExchangeRateSchema = z
    .object({
    date: dateOnlySchema,
    from: currencyCodeSchema,
    to: currencyCodeSchema.optional(),
    rate: exchangeRateSchema,
})
    .strict();
//# sourceMappingURL=rates.js.map